import useMasterTourneyDefinitionsIds from "@/src/hooks/data/useMasterTourneyDefinitionsIds";
import React, { useState, useEffect } from "react";
import { TourneyTile } from "@themed-components";
import { motion } from "framer-motion";

function A23TourneySection({ config, activeTabCode }) {
  const masterTourneyRegIds = useMasterTourneyDefinitionsIds(activeTabCode);
  const [tourneyCount, settourneyCount] = useState(20);
  const [activeIdx, setActiveIdx] = useState(0);
  const scrollRef = React.useRef(null);
  const tourneys = config.method
    ? config.method(masterTourneyRegIds)
    : config.data;

  const isLateRegistrationSection = config.key === "lateRegistration";

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    const handleScroll = () => {
      const scrollLeft = scrollContainer.scrollLeft;
      const cardWidth = 340 + 16;
      const currentIndex = Math.round(scrollLeft / cardWidth);
      setActiveIdx(Math.min(currentIndex, tourneys.length - 1));
    };

    scrollContainer.addEventListener("scroll", handleScroll, { passive: true });
    return () => scrollContainer.removeEventListener("scroll", handleScroll);
  }, [tourneys.length]);

  if (!tourneys) return null;

  const scrollToCard = (index) => {
    if (scrollRef.current) {
      const cardWidth = 340 + 16;
      scrollRef.current.scrollTo({
        left: index * cardWidth,
        behavior: "smooth",
      });
    }
  };

  // Handle both megaTourney and ticketTourney with horizontal scrolling layout
  if (
    (config.key === "megaTourney" || config.key === "ticketTourney") &&
    config.method(masterTourneyRegIds).length > 1
  ) {
    return (
      <div key={config.key}>
        <div>
          {masterTourneyRegIds?.length > 0 && tourneys.length > 0 && (
            <div>
              <div className="flex pt-2.5 flex-row items-center">
                <div
                  style={{ backgroundColor: config?.tagColor }}
                  className={`rounded-r-600  -left-1 top-0 h-6 w-1`}
                />
                <div className="text-14 ml-2 text-secondary font-normal">
                  {config.displayName}
                </div>
              </div>
              <div
                ref={scrollRef}
                className={`${
                  tourneys.length > 1
                    ? "flex snap-x flex-row pl-2 pr-4 flex-nowrap overflow-x-scroll scroll-smooth scrollbar-none"
                    : ""
                }`}
              >
                {tourneys.map((room, idx) => (
                  <div
                    key={idx}
                    className="snap-always snap-center min-w-[340px] ml-2 pb-3"
                  >
                    <TourneyTile
                      game={
                        config.data
                          ? room.tag
                          : room?.tourneyDefinitionId || room
                      }
                      status={config.key}
                      isLateReg={isLateRegistrationSection}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Active Indicator Dots */}
        {tourneys.length > 1 && (
          <div className="flex justify-center gap-1 mb-3">
            {tourneys.map((_, idx) => (
              <button
                key={idx}
                onClick={() => scrollToCard(idx)}
                className={`transition-all duration-300 ease-in-out ${
                  activeIdx === idx
                    ? "bg-foreground scale-125 rounded-200 w-3 h-1"
                    : "bg-secondary opacity-60 rounded-900 w-1 h-1"
                }`}
                aria-label={`Go to slide ${idx + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    );
  }

  const { tagColor } = config;

  return (
    <div>
      {masterTourneyRegIds?.length > 0 && tourneys.length > 0 && (
        <div id={config.key} className="mb-7">
          <div className="flex flex-row items-center gap-2 mb-3">
            <div
              style={{ backgroundColor: tagColor }}
              className={`rounded-r-600  left-0 top-0 h-6 w-1`}
            />
            <div className="text-14 text-secondary font-normal">
              {config.displayName}
            </div>
          </div>
          {tourneys
            .slice(0, tourneys.length > 20 ? tourneyCount : tourneys.length)
            .map((room, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
              >
                <div className="mx-4">
                  <TourneyTile
                    game={room}
                    isLateReg={isLateRegistrationSection}
                    status={config?.key}
                  />
                </div>
              </motion.div>
            ))}
          {tourneys.length > 20 && tourneys.length >= tourneyCount && (
            <div className="flex justify-center mt-2">
              <button
                className="text-primary text-xs"
                onClick={() => settourneyCount(tourneyCount + 20)}
              >
                Show More
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default A23TourneySection;
